<div
  class="cads-toast"
  [class.cads-toast--exiting]="isExiting()"
  [ngStyle]="accentCssVars()"
  [attr.role]="liveRole()"
  [attr.aria-live]="livePoliteness()"
>
  <cads-icon-view-bit [config]="iconConfig()" />
  <span class="cads-toast__message">{{ config().message }}</span>
</div>
